import Button from '../Button/Button';
import { useState, useEffect } from 'react';

import CustomLink from '../CustomLink/CustomLink';
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineClose } from 'react-icons/ai';
import logo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router';
import { notification, Spin, Drawer } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import Cart from '../../assets/icons/Cart';
import Magnifier from '../../assets/icons/Magnifier';
import Place from '../../assets/icons/Place';
import Close from '../../assets/icons/Close';
import { useDebounce } from 'use-debounce';
import { baseURL } from '../../utils/axios';
import 'antd/dist/antd.min.css';
import MobilesearchResult from '../MobileSearchResult/MobilesearchResult';

const Header = () => {
  let userData = JSON.parse(localStorage.getItem('userData'));
  let token = localStorage.getItem('token');
  const scart = JSON.parse(localStorage.getItem('cart'));
  const navigate = useNavigate();
  const [mobileActive, setMobileActive] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [debouncedText, setDebouncedText] = useDebounce(searchText, 1000);
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [open, setOpen] = useState(false);
  const [showLink, setShowLink] = useState(true);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const setMobileNav = () => {
    setMobileActive(!mobileActive);
  };

  //handle search
  const onFilterChange = (e) => {
    setSearchText(e.target.value);

    if (e.target.value === '') {
      setSearchResult(null);
    }
  };

  const searchApp = async () => {
    let token = localStorage.getItem('token');

    try {
      setLoading(true);
      const res = await fetch(`${baseURL}/search/${debouncedText}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSearchResult(data.data);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: 'Unable to get any result, please try again',
      });
      console.log(error);
    }
  };

  useEffect(() => {
    searchApp();
  }, [debouncedText]);

  return (
    <>
      <nav>
        <div className='header'>
          <div className='header__left'>
            <div
              className='header__left__logo'
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer' }}
            >
              <img src={logo} alt='' />
              <p>Beta</p>
            </div>
          </div>

          {showLink && (
            <div className='header__left__menu'>
              <div>
                <ScrollLink
                  to='students'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  For Students
                </ScrollLink>
              </div>
              <div>
                <ScrollLink
                  to='parents'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  For Parents
                </ScrollLink>
              </div>

              <div>
                <ScrollLink
                  to='tutors'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  Teach on PL
                </ScrollLink>
              </div>
            </div>
          )}

          <div className='header__middle mobile-d-none'>
            <div className='header__middle__input'>
              <Magnifier />
              <input
                type='search'
                placeholder='Search for school'
                value={searchText}
                onChange={(e) => onFilterChange(e)}
                onFocus={() => setShowLink(false)}
                onBlur={() => setShowLink(true)}
              />{' '}
              {loading ? (
                <Spin indicator={antIcon} />
              ) : (
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    setDebouncedText('');
                    setSearchText('');
                    setSearchResult(null);
                    setShowLink(true);
                  }}
                >
                  <Close />
                </div>
              )}
            </div>

            {searchResult && (
              <div className='header__middle__results'>
                {searchResult?.schools !== 'No data found' &&
                  searchResult?.schools?.map((el) => (
                    <div
                      className='header__middle__results__single'
                      onClick={() =>
                        navigate(`/schools/${el.link_id ? el.link_id : el.id}`)
                      }
                    >
                      <div className='header__middle__results__single__logo'>
                        <img src={el?.logo} alt='' />
                      </div>
                      <div className='header__middle__results__single__details'>
                        <p className='header__middle__results__single__details__name'>
                          {el?.name}
                        </p>
                        <div className='header__middle__results__single__details__location'>
                          <Place />
                          <p>{el?.state},Nigeria</p>
                        </div>
                      </div>
                    </div>
                  ))}

                {searchResult?.courses !== 'No data found' &&
                  searchResult?.courses?.map((el) => (
                    <div
                      className='header__middle__results__single'
                      onClick={() =>
                        navigate(
                          `/courses/${el.title}-${el.id}?school=${el?.school?.id}`
                        )
                      }
                    >
                      <div className='header__middle__results__single__logo'>
                        <img src={el?.school?.logo} alt='' />
                      </div>
                      <div className='header__middle__results__single__details'>
                        <p className='header__middle__results__single__details__name'>
                          {el?.title}
                        </p>
                        <div className='header__middle__results__single__details__location'>
                          <p>{el?.school?.name}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className='header__right'>
            {userData ? (
              <div className='header__right__menu'>
                {scart?.length > 0 && (
                  <div className='cart' onClick={() => navigate('/cart')}>
                    <div className='cart-count'>
                      <p>{scart?.length || 0}</p>
                    </div>
                    <Cart />
                  </div>
                )}
                <Button
                  className='primary-btn'
                  text='Dashboard'
                  onClick={() =>
                    navigate(
                      userData.school ? '/tutor-dashboard' : '/dashboard'
                    )
                  }
                />
              </div>
            ) : (
              <div className='header__right__menu'>
                {scart?.length > 0 && (
                  <div className='cart' onClick={() => navigate('/cart')}>
                    <div className='cart-count'>
                      <p>{scart?.length || 0}</p>
                    </div>
                    <Cart />
                  </div>
                )}
                <CustomLink to='/login'>Log In</CustomLink>
                <Button
                  className='primary-btn'
                  text='Sign Up'
                  onClick={() => navigate('/student-signup')}
                />
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '18px' }}>
            {mobileActive ? (
              <>
                <div className='hamburger' onClick={() => showDrawer()}>
                  <Magnifier />
                </div>

                <div className='hamburger' onClick={() => setMobileNav()}>
                  <AiOutlineClose />
                </div>
              </>
            ) : (
              <>
                <div className='hamburger' onClick={() => showDrawer()}>
                  <Magnifier />
                </div>
                <div className='hamburger' onClick={() => setMobileNav()}>
                  <GiHamburgerMenu />
                </div>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={mobileActive ? `overlay` : `remove_overlay`}>
        {mobileActive && (
          <ul className={`overlay_menu`}>
            <li>
              <CustomLink to='/'>Home</CustomLink>
            </li>

            <li>
              <div>
                <ScrollLink
                  to='students'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  For Students
                </ScrollLink>
              </div>
            </li>
            <li>
              <div>
                <ScrollLink
                  to='parents'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  For Parents
                </ScrollLink>
              </div>
            </li>

            <li>
              <div>
                <ScrollLink
                  to='tutors'
                  smooth={true}
                  offset={50}
                  duration={500}
                >
                  {' '}
                  Teach on PL
                </ScrollLink>
              </div>
            </li>

            {!token && (
              <li>
                <CustomLink to='/login'> Log In</CustomLink>
              </li>
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                alignItems: 'center',
                marginTop: '30px',
              }}
            >
              <div className='cart' onClick={() => navigate('/cart')}>
                <div className='cart-count'>
                  <p>{scart?.length || 0}</p>
                </div>
                <Cart />
              </div>

              {token ? (
                <Button
                  className='primary-btn'
                  text='Dashboard'
                  onClick={() => navigate('/dashboard')}
                />
              ) : (
                <Button
                  className='primary-btn'
                  text='Sign Up'
                  onClick={() => navigate('/student-signup')}
                />
              )}
            </div>
          </ul>
        )}
      </div>

      <Drawer placement={'left'} onClose={onClose} key={'left'} visible={open}>
        <MobilesearchResult />
      </Drawer>
    </>
  );
};

export default Header;
